import React from 'react';

import {ProgressCollapsedDots} from '@/components/ui/ProgressCollapsedDots/ProgressCollapsedDots';
import {calculateVisibleElements} from '@/services/loyalty/progressUtils';
import {twx} from '@/utils/tailwindUtils';

const BadgeProgress = ({stepsCount = 0, finishedStepsCount = 0}) => {
    const {visibleCircles, collapsedStart, collapsedEnd} = calculateVisibleElements(stepsCount, finishedStepsCount);

    return (
        <div
            className='flex w-full flex-row items-center gap-1 bg-tertiary/10 p-4'
            role='progressbar'
            aria-valuenow={finishedStepsCount}
            aria-valuemin={0}
            aria-valuemax={stepsCount}
            aria-hidden
        >
            {collapsedStart && <ProgressCollapsedDots className='bg-primary-dark' dotClassName='bg-romance' />}
            {collapsedStart && <Line />}

            {visibleCircles.map(({isFinished}, index) => (
                <React.Fragment key={index}>
                    {isFinished ? <Circle /> : <CircleInactive />}
                    {index < visibleCircles.length - 1 && (isFinished ? <Line /> : <LineInactive />)}
                </React.Fragment>
            ))}

            {collapsedEnd && <LineInactive />}
            {collapsedEnd && <ProgressCollapsedDots className='bg-primary-dark opacity-60' dotClassName='bg-romance' />}
        </div>
    );
};

const Circle = ({className}) => (
    <div className={twx('h-2.5 w-2.5 rounded-full border border-primary-dark bg-primary-dark', className)} />
);
const CircleInactive = () => <Circle className='bg-transparent opacity-60' />;

const Line = ({className}) => <div className={twx('h-0.5 flex-1 rounded-full bg-primary-dark', className)} />;
const LineInactive = () => <Line className='opacity-60' />;

export default BadgeProgress;
